export default __webpack_public_path__ + "static/media/gestaoDeRedesSociais.47010e8f.svg";